import { FC } from "react";
import ShareIcon from "@mui/icons-material/Share";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { stylesGeneralComponents } from "../../../../StylesMuiGeneralComponents";
import {
  BinSelectedInfo,
  LocationGrainTrackerValues,
  LocationSelectedIs,
  PrincipalInfoGT,
  SelectedLocation,
} from "../../../../../redux/slices/grainTracker/grainTrackerTypes";
import { NavigateFunction } from "react-router-dom";
import { LocationSelectedDetails } from "../../../../../redux/actions/locations/locationsTypes";
import { State } from "../../../../../redux/slices";
import { useSelector } from "react-redux";

type SecondMenuLocationDetailsParams = {
  t: (arg0: string) => string;
  isLocationShared: boolean;
  isBinSelected: boolean;
  locationSelectedDetails: any;
  selectedBin: {
    values: undefined | BinSelectedInfo;
    loading: boolean;
    error: string;
  };
  redirectToEditLocation: (
    selectedLocation: SelectedLocation,
    navigate: NavigateFunction,
    locationSelectedIs: { EditingStockage: boolean; EditingValues: boolean }
  ) => void;
  navigate: NavigateFunction;
  locationSelectedIs: LocationSelectedIs;
  locationGrainTrackerValues: LocationGrainTrackerValues;
  redirectToEditStorage: (
    selectedLocation: LocationSelectedDetails,
    navigate: NavigateFunction,
    locationSelectedIs: {
      EditingStockage: boolean;
    },
    graintrackerValues: LocationGrainTrackerValues
  ) => void;

  setInformationByClicking: (
    binInformation: any,
    principalInfoGT: PrincipalInfoGT,
    principalInfoGTCopy: PrincipalInfoGT,
    token: string
  ) => void;
  capacity: number;
  selectedLocation: SelectedLocation;
  successShareDeleteBins: boolean;
  setSelectedSiteToShare: (
    navigate: NavigateFunction,
    selectedSiteToShare: {
      name: string;
      id: string;
    }
  ) => void;
};

const SecondMenuLocationDetails: FC<SecondMenuLocationDetailsParams> = ({
  t,
  isLocationShared,
  isBinSelected,
  locationSelectedDetails,
  selectedBin,
  redirectToEditLocation,
  navigate,
  locationSelectedIs,
  locationGrainTrackerValues,
  redirectToEditStorage,
  capacity,
  selectedLocation,
  successShareDeleteBins,
  setSelectedSiteToShare,
  setInformationByClicking,
}) => {
  const { principalInfoGT, principalInfoGTCopy } = useSelector(
    (state: State) => state.GrainWiseEditionReducer
  );

  const { user } = useSelector((state: State) => state.Authentication);

  return (
    <div className="site-second-info-details">
      <div className="site-detail-main-title">
        {isLocationShared ? (
          <ShareIcon sx={stylesGeneralComponents.shareIcon} />
        ) : (
          ""
        )}
        {!isBinSelected
          ? locationSelectedDetails?.name
          : selectedBin?.values?.name}
      </div>
      <div>
        {!isLocationShared ? (
          <Button
            sx={{ textTransform: "none" }}
            variant="outlined"
            endIcon={<EditIcon />}
            onClick={() => {
              if (isBinSelected) {
                redirectToEditStorage(
                  locationSelectedDetails,
                  navigate,
                  locationSelectedIs,
                  locationGrainTrackerValues
                );

                setInformationByClicking(
                  selectedBin.values,
                  principalInfoGT,
                  principalInfoGTCopy,
                  user?.token as string
                );
              } else {
                redirectToEditLocation(
                  { ...selectedLocation, values: locationSelectedDetails },
                  navigate,
                  locationSelectedIs
                );
              }
            }}
          >
            {t("Gran_tracker_bins.edit-button")}
          </Button>
        ) : (
          ""
        )}
        {capacity >= 0.1 && !isLocationShared ? (
          <Button
            sx={{ textTransform: "none", marginLeft: "10px" }}
            variant="contained"
            endIcon={<ShareIcon />}
            disabled={successShareDeleteBins}
            onClick={() =>
              setSelectedSiteToShare(navigate, {
                name: locationSelectedDetails?.name ?? "",
                id: locationSelectedDetails?.id,
              })
            }
          >
            {t("Share_site.share-button")}
          </Button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
export default SecondMenuLocationDetails;
